import React, { useState, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import filterDataForList from '../common/functions/filterDataForList';
import schema from './jsonSchema';
import AdvanceList from '../common/AdvanceList';
import DirectoryService from './DirectoryService';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
const UserList = () => {
  const [data, setData] = useState();
  const [users, setUsers] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [exportToExcelData, setExportToExcelData] = useState();

  const refreshData = data => {
    console.log(data);
    DirectoryService.retrieveUsersByAccount()
      .then(data => {
        const updatedData = {
          ...data,
          jobTitle: data.contract?.jobType,
          department: data.contract?.department,
          location: data.contract?.location
        }
        setUsers(updatedData);
        setData(
          filterDataForList(
            updatedData,
            columns.map(c => c.accessor),
            transformUserDataFunction
          )
        );
        setNoDataToShow(!data.length > 0);
        const exportToExcelData = data.map(x => ({
          identifier: x.identifier,
          email: x.email
        }));
        setExportToExcelData(exportToExcelData);
      })
      .catch(error => setError({ error: error.message }));
  };
  const bulkActions = (selectedRows, action) => {
    console.log(selectedRows);
    console.log(action);
    Object.keys(selectedRows).forEach(element => {
      const identifier = users[element].identifier;
      console.log(identifier);
      if ('delete' === action) {
        DirectoryService.deleteUserProfile(identifier)
          .then(value => {
            console.log(value);
            refreshData(data);
          })
          .catch(error => console.log(error));
      }
    });
  };
  const transformUserDataFunction = (attr, item) => {
    if (attr == 'email') {
      const url = '/social/directory/user-details/' + item['identifier'];
      return <Link to={url}>{item[attr]}</Link>;
    }
    return item[attr];
  };
  const cols = [
    {
      accessor: 'firstName',
      Header: 'Name',
      headerProps: { className: 'pe-1' },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { firstName, lastName, avatar, identifier } = rowData.row.original;

        const name = firstName + ' ' + lastName;
        const link = '/social/directory/user-details/' + identifier;
        return (
          <Link to={link}>
            <Flex alignItems="center">
              {avatar ? (
                <Avatar src={avatar} size="xl" className="me-3" />
              ) : (
                <Avatar size="xl" name={avatar} className="me-3" />
              )}
              <div className="flex-1">
                <h5 className="mb-0 fs--1">{name}</h5>
              </div>
            </Flex>
          </Link>
        );
      }
    },
    {
      accessor: 'email',
      Header: 'Email',
      Cell: rowData => {
        const { email } = rowData.row.original;
        return <a href={`mailto:${email}`}>{email}</a>;
      }
    },
    {
      accessor: 'jobTitle',
      Header: 'Job Title'
    },
    {
      accessor: 'department',
      Header: 'Department'
    },
    {
      accessor: 'location',
      Header: 'Location'
    } 
  ] 
  useEffect(() => {
    const jsonSchema = schema;

    setColumns(cols);
    console.log(exportToExcelData);
    DirectoryService.retrieveUsersByAccount()
      .then(data => {
        const updatedData = data.map(user => ({
          ...user,
          jobTitle: user.contract?.jobType,
          department: user.contract?.department,
          location: user.contract?.location
        }));
        
        setUsers(updatedData);
        /*setData(
          filterDataForList(
            data,
            columns.map(c => c.accessor),
            transformUserDataFunction
          )
        );*/
        setData(updatedData);
        setNoDataToShow(!updatedData.length > 0);
        const exportToExcelData = data.map(x => ({
          identifier: x.identifier,
          email: x.email
        }));
        setExportToExcelData(exportToExcelData);
      })
      .catch(error => setError({ error: error.message }));
  }, [noDataToShow]);
  return (
    <>
      {error}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any User to show. Let's create a new one!
        </Alert>
      )}
      {data && (
        <AdvanceList
          columns={columns}
          data={data}
          selection={DirectoryService.isLoggedByHRAdmin()}
          searchBox={true}
          bulkActions={DirectoryService.isLoggedByHRAdmin()}
          bulkActionsFx={() => {
            console.log('Adavanced list');
          }}
        />
      )}
    </>
  );
};

export default UserList;
